import api from "../api";

export const storageKentaService = {
  GetAllBlobs: async () => {
    try {
      const { data } = await api.get("/v1/HearingFile/GetAllBlobs");

      return {
        success: true,
        body: data.data,
      };
    } catch (error) {
      return {
        success: false,
        body: {},
      };
    }
  },
};
